import { useFormatPrice } from 'hooks/formatting/useFormatPrice';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { TescomaClubIcon } from 'public/svg/IconsSvg';
import { LoyaltyClubPointsWithPriceType } from 'types/price';
import twMerge from 'utils/twMerge';

type LoyaltyClubEarnedProps = {
    pointsWithPrice: LoyaltyClubPointsWithPriceType;
    isSimplified?: boolean;
    className?: string;
    isInSummary?: boolean;
};

export const LoyaltyClubEarned: FC<LoyaltyClubEarnedProps> = ({
    pointsWithPrice,
    isSimplified = true,
    className,
    isInSummary,
}) => {
    const testIdentifier = 'loyaltyclub-earned';
    const t = useTypedTranslationFunction();
    const { formatPriceNumber: formatPrice } = useFormatPrice();

    if (
        pointsWithPrice.loyaltyClubPoints === null ||
        pointsWithPrice.loyaltyClubPoints < 1 ||
        pointsWithPrice.loyaltyClubPointsPrice === null
    ) {
        return null;
    }

    const getClasses = () => {
        if (isInSummary && !isSimplified) {
            return 'text-left vl:text-center';
        }
        if (!isSimplified) {
            return 'text-center vl:text-right';
        }

        return 'text-left';
    };

    return (
        <div
            className={twMerge('mb-5 text-small leading-6 vl:mb-8', getClasses(), className)}
            data-testid={testIdentifier}
        >
            {`${t('By purchasing you will get points worth')} `}
            {isSimplified ? (
                formatPrice(pointsWithPrice.loyaltyClubPointsPrice)
            ) : (
                <span className="whitespace-nowrap">
                    <strong>{formatPrice(pointsWithPrice.loyaltyClubPointsPrice)}</strong>
                    <TescomaClubIcon className="-mt-1 ml-1 h-4 w-4 text-red" />
                </span>
            )}
        </div>
    );
};
